import { createContext, useEffect, useState, useContext } from 'react'

const ThemeContext = createContext()
const THEME_STORAGE_KEY = 'fabits-theme'

const getInitialTheme = () => {
  if (typeof window === 'undefined') return false

  const storedTheme = localStorage.getItem(THEME_STORAGE_KEY) || localStorage.getItem('theme')
  if (storedTheme === 'dark') return true
  if (storedTheme === 'light') return false

  return document.documentElement.classList.contains('dark')
}

const ThemeCtxProvider = ({ children }) => {
  const [darkMode, setDarkMode] = useState(getInitialTheme)

  useEffect(() => {
    document.documentElement.classList.toggle('dark', darkMode)
    document.documentElement.dataset.theme = darkMode ? 'dark' : 'light'
    localStorage.setItem(THEME_STORAGE_KEY, darkMode ? 'dark' : 'light')
    localStorage.setItem('theme', darkMode ? 'dark' : 'light')
  }, [darkMode])

  const toggleDarkMode = (value) => {
    setDarkMode((currentMode) => (typeof value === 'boolean' ? value : !currentMode))
  }

  return (
    <ThemeContext.Provider value={{ darkMode, toggleDarkMode }}>{children}</ThemeContext.Provider>
  )
}

// export { ThemeCtxProvider, ThemeContext }

const useThemeMode = () => {
  return useContext(ThemeContext)
}

export { useThemeMode, ThemeCtxProvider }
